import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/applications/Configurator")
);

const ComponentEditConfig = {
  emptyLabel: "Vehicle Configurator - Build Config",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};


const Configurator = (props) => {
  return <Component {...props} />;
};

export default withAemIntegration("lexus/components/build")(Configurator, ComponentEditConfig);
